'use client';
/**
 * `useEngineerIdentity` — the raw, un-overlaid auth state for telemetry
 * attribution, relocated from the frontend into the SDK as part of the
 * auth-cutover (spec 009, FILE 14, Group B/C).
 *
 * Returns the engineer's own identity even when impersonation is active.
 * Spec 048 FR-035: telemetry must always attribute to the engineer (the
 * operator), never to the impersonated target. Calling `useAuth()` here
 * would return the impersonated user — calling `useEngineerIdentity()` returns
 * the real session without any overlay.
 *
 * Use this hook ONLY for telemetry / observability surfaces (Better Stack
 * identify, Statsig identify, Canny identify). For any UI that should
 * reflect the impersonated user, use `useAuth()` instead.
 *
 * Platform-neutral: reads only the SDK-owned auth store via `useMorfiAuth`.
 * No web/RN globals. Safe in `src/auth/` core per
 * `.claude/rules/platform-agnostic.md`.
 */
import { useAuthActions } from './auth-actions-context.js';
import { useMorfiAuth } from './use-morfi-auth.js';
/**
 * Returns the engineer's own auth state without any impersonation overlay.
 *
 * Drop-in replacement for the old
 * `frontend/src/hooks/auth/use-engineer-identity.ts`.
 * Import from `@morfi/backend-sdk-v2/client`.
 */
export function useEngineerIdentity() {
    const { status, user } = useMorfiAuth();
    const actions = useAuthActions();
    return {
        isAuthenticated: status === 'authed',
        isLoading: status === 'loading',
        user,
        error: null,
        ...actions,
    };
}
//# sourceMappingURL=use-engineer-identity.js.map